export const truckDatabase = {

  SMALL_PEDDLER: {
    name: "Small / Peddler Tanker",
    description: "Off-grid commercial supply, remote farms and residential estates.",
    capacity: {
      litres: 5000,
      bbl: 31.45,
      metricTon: 4.3
    }
  },

  LIGHT_COMMERCIAL: {
    name: "Light Commercial Tanker",
    description: "Independent marketers, construction sites and industrial users.",
    capacity: {
      litres: 10000,
      bbl: 62.90,
      metricTon: 8.5
    }
  },

  MEDIUM_RIGID: {
    name: "Medium Rigid Tanker",
    description: "Multi-stop distribution and urban supply to filling stations.",
    capacity: {
      litres: 18000,
      bbl: 113.23,
      metricTon: 15.3
    }
  },

  LARGE_RIGID: {
    name: "Large Rigid Tanker",
    description: "Regional product distribution and high-volume deliveries.",
    capacity: {
      litres: 25000,
      bbl: 157.25,
      metricTon: 21.3
    }
  },

  TANKER_TRAILER: {
    name: "Large Tanker Trailer",
    description: "Primary depot-to-depot and depot-to-terminal transportation.",
    capacity: {
      litres: 33000,
      bbl: 207.57,
      metricTon: 28.1
    }
  },

  ARTICULATED_SUPER: {
    name: "Articulated Super Tanker",
    description: "Maximum-capacity highway tanker for bulk petroleum distribution.",
    capacity: {
      litres: 45000,
      bbl: 283.05,
      metricTon: 38.3
    }
  }

};